<template>
  <div>
    <div class="aisea-text-12-400-gray">{{ form.label }}</div>
    <div class="px-2">{{ inputValue }}</div>
  </div>
</template>
  
  <script>

import { DeviceInfoMixin, ColorMixin } from "@/mixins";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    form: { type: Object, required: true },
    value: { required: false }
  },
  data () {
    return {
      inputValue: null,
    }
  },
  components: {

  },
  watch: {
    inputValue: {
      handler (val) {
        const payload = {
          id: this.form.id,
          label: val,
          value: val,
          isAlert: this.isAlert
        };
        this.$emit("setValue", payload)
      },
      deep: true,
    },
  },
  computed: {
    isAlert () {
      return false;
    }
  },
  methods: {

  },
  mounted () {
    if (this.value) {
      this.inputValue = this.value;
      return;
    }
    this.inputValue = this.form.default_value;
  }
}
  </script>
  
  <style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-report-list {
  --vs-primary: 3, 155, 229;
}
